/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The MFA method used for authentication.
*/
export enum AuditLogMfaMethod {
  AuthenticatorApp = 'AUTHENTICATOR_APP'
}
